import React from 'react'
import './testimonial.css'
function Testimonial() {
   
    
  
      return (
        <section id="testimonials">
        <div className="text-container">
           <div className="row">
  
              <div className="two columns header-col">
                 <h1><span>Client Testimonials</span></h1>
              </div>
  
              <div className="ten columns flex-container">
                    <ul className="slides">
                    <blockquote>
                 <p>Peh is a good guy who is calm in working with. He develop my website for me ,which has help me in my cashew buying business .All companies and individuals looking for talented developers should employ peh. </p>
                 <cite>Mr.Amos</cite>
              </blockquote>
             
                    </ul>
                 </div>
              </div>
           </div>
     </section>
      );
    }
  

export default Testimonial
